import React from "react";
import { Label } from "@/components/atoms/texts/label";
import PrintErrorMessage from "@/components/organisms/feedback/PrintErrorMessage";
import PrintInformationMessage from "@/components/organisms/feedback/PrintInformationMessage";
import Payslip from "@/components/macro-organisms/tabs/consultants-vision-admin/payslib/payslip";

export default function ListOfPayslips({ usersDataCopy, unknownPayslips, submissionError, setPayslip, removePayslip }) {
    return (
        <div className="flex flex-col gap-thirdDegree p-4">
            {submissionError && <PrintErrorMessage error={submissionError} />}
            {submissionError && <PrintInformationMessage information="information.payslipsNotAdded"/>}
            {usersDataCopy?.length > 0 && <Label fontWeight="bold" size="h4" message="consultants.payslip.recognized"></Label>}
            {(usersDataCopy?.length > 0 && !submissionError) && <PrintInformationMessage information="information.editAndSendPayslips" />}
            {usersDataCopy?.map((user, index) => (
                <div key={index} className="flex flex-col gap-firstDegree">
                    <span>
                        <Label message="consultants.payslip.consultant" /> : <Label fontWeight="bold">{user.trigram} - {user.firstname} {user.lastname}</Label>
                    </span>
                    <div className="flex flex-col gap-firstDegree">
                        {user.payslips.map((item, idx) => (
                            <Payslip
                                key={idx}
                                data={item}
                                editable
                                minimized
                                dataOwner
                                forMassiveInput
                                hideInputFile
                                showAllInformations
                                setPayslip={setPayslip}
                                removePayslip={removePayslip}
                            />
                        ))}
                    </div>
                </div>
            ))}
            {unknownPayslips?.length > 0 && <Label fontWeight="bold" size="h4" message="consultants.payslip.notRecognized"></Label>}
            {unknownPayslips?.length > 0 && <PrintInformationMessage information="information.addInformationPayslips" />}

            {unknownPayslips?.map((payslip, idx) => (
                <Payslip
                    key={idx}
                    data={payslip}
                    editable
                    minimized
                    dataOwner
                    showAllInformations
                    
                    forMassiveInput
                    showProfileInput={false}
                    hideInputFile
                    setPayslip={setPayslip}
                    removePayslip={removePayslip}
                />
            ))}
        </div>
    );
}
